import React, { useEffect, useRef, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Button } from "@progress/kendo-react-buttons";
import { Typography } from "@progress/kendo-react-common";
import {
  Field,
  Form,
  FormElement,
  FormRenderProps,
} from "@progress/kendo-react-form";
import { GridLayout, GridLayoutItem } from "@progress/kendo-react-layout";
import { requiredValidator } from "../../components/formFields/CommonValidator";
import ShadowCard from "../../components/common/ShadowCard";
import ButtonWithLoading from "../../components/common/ButtonWithLoading";
import { useAppDispatch, useAppSelector } from "../../app/hooks";
import { LoadingPanel } from "../../components/layout/Loading";
import FormTextField from "../../components/formFields/FormTextField";
import FormSelectionField from "../../components/formFields/FormSelectionField";
import { STATUSARRAY } from "../../_contstants/common";
import FormImageUpload from "../../components/formFields/FormImageUpload";
import {
  createEvents,
  deleteEventsImage,
  EventsImageUpload,
  getEventsByID,
  updateEvents,
} from "./services/event.services";

import {
  clearEventDetails,
  clearEventImageID,
  seteventImageID,
} from "./eventSlice";
// import FormRichTextField from "../../components/formFields/FormRichTextField";
import FormTextArea from "../../components/formFields/FormTextArea";
import { getFile, slugify } from "../../_helper/helper";
import FormRichTextField from "../../components/formFields/FormRichTextField";
import IconComponent from "../../components/common/IconComponent";
import { MdDelete } from "react-icons/md";
import { closeDialog, openDialog } from "../../components/dialog/dialogSlice";
import AppDialog, { DialogCloseButton } from "../../components/dialog/Dialog";

const CreateEvent: React.FC = () => {
  const dispatch = useAppDispatch();
  const gridRef = useRef<any>(null);
  const navigate = useNavigate();
  const location = useLocation();
  const EventID = location.state?.EventID;
  const EventDetail = useAppSelector((state) => state.event.EventDetail);
  const loading = useAppSelector((state) => state.event.loading);
  const [formKey, setFormKey] = useState(1);

  useEffect(() => {
    setFormKey(formKey + 1);
  }, [EventDetail]);

  useEffect(() => {
    if (EventID) {
      dispatch(getEventsByID(EventID));
    }
    return () => {
      dispatch(clearEventDetails());
    };
  }, [EventID]);

  const handleSubmit = async (values: any) => {
    const formData = {
      Title: values?.Title ? values?.Title : "",
      URL: values?.URL ? values?.URL : "",
      Tagline: values?.Tagline ? values?.Tagline : "",
      Availability: values?.Availability ? values?.Availability : "",
      Capacity: "",
      RomanticSettings: values.RomanticSettings ? values?.RomanticSettings : "",
      GuestCapacity: values?.GuestCapacity ? values?.GuestCapacity : "",
      CustomPackages: values.CustomPackages ? values?.CustomPackages : "",
      ShortDescription: values?.ShortDescription
        ? values?.ShortDescription
        : "",
      LongDescription: values?.LongDescription ? values?.LongDescription : "",
      PackageHighlights: values?.PackageHighlights
        ? values?.PackageHighlights
        : "",
      Inclusion: values?.Inclusion ? values?.Inclusion : "",
      Exclusion: values?.Exclusion ? values?.Exclusion : "",
      MetaTitle: values?.MetaTitle ? values?.MetaTitle : "",
      MetaDescription: values?.MetaDescription ? values?.MetaDescription : "",
      MetaKeywords: values?.MetaKeywords ? values?.MetaKeywords : "",
      IsActive: values.IsActive === 1,
    };
    const ImageData = new FormData();
    const MainImage =
      values?.MainImage && typeof values?.MainImage !== "string"
        ? getFile(values?.MainImage)
        : "";
    const BannerImage =
      values?.BannerImage && typeof values?.BannerImage !== "string"
        ? getFile(values?.BannerImage)
        : "";
    // const ImageGallery =
    //   values?.ImageGallery && typeof values?.ImageGallery !== "string"
    //     ? getFile(values?.ImageGallery)
    //     : "";

    try {
      if (EventID) {
        const editPayload = {
          ...formData,
          ID: EventID,
        };

        const response = await dispatch(updateEvents(editPayload));
        if (response?.meta?.requestStatus === "fulfilled") {
          if (
            (values?.MainImage && typeof values?.MainImage !== "string") ||
            (values?.BannerImage && typeof values?.BannerImage !== "string") ||
            // (values?.ImageGallery && typeof values?.ImageGallery !== "string")
            values?.ImageGallery?.length > 0
          ) {
            if (values?.ImageGallery && Array.isArray(values.ImageGallery)) {
              values.ImageGallery.forEach((image: any) => {
                if (image.attachment && typeof image.attachment !== "string")
                  return;
                const attachment = getFile(image);
                if (attachment) {
                  ImageData.append("ImageGallery", attachment);
                }
              });
            }
            ImageData.append("MainImage", MainImage);
            ImageData.append("BannerImage", BannerImage);
            // ImageData.append("ImageGallery", ImageGallery);
            ImageData.append("ID", EventID);
            await dispatch(EventsImageUpload(ImageData));
          }
          navigate("/event");
          dispatch(clearEventDetails());
        }
      } else {
        const response = await dispatch(createEvents(formData));
        if (response?.meta?.requestStatus === "fulfilled") {
          if (
            ((values?.MainImage && typeof values?.MainImage !== "string") ||
              (values?.BannerImage &&
                typeof values?.BannerImage !== "string") ||
              // (values?.ImageGallery &&
              //   typeof values?.ImageGallery !== "string")
              values?.ImageGallery?.length > 0) &&
            response?.payload?.Data?.ID
          ) {
            if (values?.ImageGallery && Array.isArray(values.ImageGallery)) {
              values.ImageGallery.forEach((image: any) => {
                if (image.attachment && typeof image.attachment !== "string")
                  return;
                const attachment = getFile(image);
                if (attachment) {
                  ImageData.append("ImageGallery", attachment);
                }
              });
            }
            ImageData.append("MainImage", MainImage);
            ImageData.append("BannerImage", BannerImage);
            // ImageData.append("ImageGallery", ImageGallery);
            ImageData.append("ID", response?.payload?.Data?.ID);
            await dispatch(EventsImageUpload(ImageData));
          }
          navigate("/event");
          dispatch(clearEventDetails());
        }
      }
    } catch (error) {
      console.error("Error in handleSubmit:", error);
      throw error;
    }
  };

  const handleDeleteImage = (ID: number) => {
    dispatch(openDialog("deleteEventImage"));
    dispatch(seteventImageID(ID));
  };

  const handleCreateSlug = (e: any, formRenderProps: FormRenderProps) => {
    const slug = slugify(e.value);
    formRenderProps.onChange("URL", { value: slug });
  };

  // if (loading) return <LoadingPanel gridRef={gridRef} />;
  return (
    <>
      {loading && <LoadingPanel gridRef={gridRef} />}
      <DeleteEventImageDialog />
      <div>
        <Form
          onSubmit={handleSubmit}
          key={formKey}
          initialValues={EventDetail}
          render={(formRenderProps: FormRenderProps) => (
            <FormElement>
              <ShadowCard style={{ padding: 12, marginBottom: 20 }}>
                <GridLayout
                  style={{ marginRight: 20 }}
                  gap={{ rows: 5, cols: 10 }}
                  cols={[
                    { width: "33.33%" },
                    { width: "33.33%" },
                    { width: "33.33%" },
                  ]}
                >
                  <GridLayoutItem colSpan={2}>
                    <Typography.h4>
                      {EventID ? "Update Event" : "Add Event"}
                    </Typography.h4>
                  </GridLayoutItem>
                  <GridLayoutItem
                    style={{
                      textAlign: "end",
                    }}
                  >
                    <div>
                      <ButtonWithLoading
                        label={EventID ? "Update" : "Save"}
                        type="submit"
                        disabled={!formRenderProps.allowSubmit || loading}
                        loading={loading}
                      />
                      <Button
                        type="button"
                        fillMode={"outline"}
                        themeColor={"primary"}
                        style={{ marginLeft: 10 }}
                        onClick={() => navigate("/event")}
                      >
                        Cancel
                      </Button>
                    </div>
                  </GridLayoutItem>
                  <GridLayoutItem colSpan={2}>
                    <Field
                      name="Title"
                      label="Title"
                      placeholder="Title"
                      component={FormTextField}
                      validator={requiredValidator}
                      astrike={true}
                      onChange={(e: any) =>
                        handleCreateSlug(e, formRenderProps)
                      }
                    />
                  </GridLayoutItem>
                  <GridLayoutItem>
                    <Field
                      name="URL"
                      label="URL"
                      placeholder="URL"
                      component={FormTextField}
                      validator={requiredValidator}
                      astrike={true}
                    />
                  </GridLayoutItem>
                  <GridLayoutItem colSpan={2}>
                    <Field
                      name="Tagline"
                      label="Tagline"
                      placeholder="Tagline"
                      component={FormTextField}
                      validator={requiredValidator}
                      astrike={true}
                    />
                  </GridLayoutItem>
                  <GridLayoutItem>
                    <Field
                      name="Availability"
                      label="Availability"
                      placeholder="Availability"
                      component={FormTextField}
                      validator={requiredValidator}
                      astrike={true}
                    />
                  </GridLayoutItem>
                  <GridLayoutItem colSpan={1}>
                    <Field
                      name="RomanticSettings"
                      label="Romantic Settings"
                      placeholder="Romantic Settings"
                      component={FormTextField}
                      // validator={requiredValidator}
                      // astrike={true}
                    />
                  </GridLayoutItem>
                  <GridLayoutItem colSpan={1}>
                    <Field
                      name="GuestCapacity"
                      label="Guest Capacity"
                      placeholder="i.e. 0 - 50"
                      component={FormTextField}
                      validator={requiredValidator}
                      astrike={true}
                    />
                  </GridLayoutItem>
                  <GridLayoutItem colSpan={1}>
                    <Field
                      name="CustomPackages"
                      label=" Custom Packages"
                      placeholder="Enter Amout/-"
                      component={FormTextField}
                      // validator={requiredValidator}
                      // astrike={true}
                    />
                  </GridLayoutItem>
                  <GridLayoutItem colSpan={3}>
                    <Field
                      name="ShortDescription"
                      label="Short Description"
                      placeholder="Short Description"
                      component={FormRichTextField}
                      style={{ height: 200 }}
                    />
                  </GridLayoutItem>
                  <GridLayoutItem colSpan={3}>
                    <Field
                      name="LongDescription"
                      label="Long Description"
                      placeholder="Long Description"
                      component={FormRichTextField}
                      style={{ height: 200 }}
                    />
                  </GridLayoutItem>
                  <GridLayoutItem colSpan={1}>
                    <Field
                      name="PackageHighlights"
                      label="Package Highlights"
                      placeholder="Package Highlights"
                      component={FormRichTextField}
                      style={{ height: "auto" }}
                    />
                  </GridLayoutItem>
                  <GridLayoutItem colSpan={1}>
                    <Field
                      name="Inclusion"
                      label="Inclusion"
                      placeholder="Inclusion"
                      component={FormRichTextField}
                      style={{ height: "auto" }}
                    />
                  </GridLayoutItem>
                  <GridLayoutItem colSpan={1}>
                    <Field
                      name="Exclusion"
                      label="Exclusion"
                      placeholder="Exclusion"
                      component={FormRichTextField}
                      style={{ height: "auto" }}
                    />
                  </GridLayoutItem>
                  <GridLayoutItem colSpan={3}>
                    <Field
                      name="MetaTitle"
                      label="Meta Title"
                      placeholder="Meta Title"
                      component={FormTextField}
                    />
                  </GridLayoutItem>
                  <GridLayoutItem colSpan={3}>
                    <Field
                      name="MetaKeywords"
                      label="Meta Keywords"
                      placeholder="Meta Keywords"
                      component={FormTextField}
                    />
                  </GridLayoutItem>
                  <GridLayoutItem colSpan={3}>
                    <Field
                      name="MetaDescription"
                      label="Meta Description"
                      placeholder="Meta Description"
                      component={FormTextArea}
                    />
                  </GridLayoutItem>

                  <GridLayoutItem>
                    <Field
                      justifyContent="start"
                      name={`MainImage`}
                      label="Main Image"
                      type="file"
                      accept="image/*"
                      alternateName="Main Image"
                      component={FormImageUpload}
                    />
                  </GridLayoutItem>
                  <GridLayoutItem>
                    <Field
                      justifyContent="start"
                      name={`BannerImage`}
                      label="Banner Image"
                      type="file"
                      accept="image/*"
                      alternateName="Banner Image"
                      component={FormImageUpload}
                    />
                  </GridLayoutItem>

                  <GridLayoutItem>
                    <Field
                      justifyContent="start"
                      name={`ImageGallery`}
                      label="Image Gallery"
                      type="file"
                      multiple={true}
                      accept="image/*"
                      alternateName="Image Gallery"
                      component={FormImageUpload}
                    />
                  </GridLayoutItem>
                  {EventDetail?.EventInnerimage &&
                    EventDetail?.EventInnerimage?.length > 0 && (
                      <GridLayoutItem colSpan={3} className="mt-3">
                        <div className="card shadow-sm border-0">
                          {EventDetail?.EventInnerimage?.length > 0 && (
                            <div
                              className="card-body p-2 pt-3 pe-3"
                              style={{
                                background: "#f8f9fa",
                                borderRadius: "8px",
                                border: "1px solid #e0e0e0",
                              }}
                            >
                              <div className="d-flex justify-content-between align-items-center mb-3">
                                <h5
                                  className="mb-0"
                                  style={{
                                    color: "#2c3e50",
                                    fontWeight: "600",
                                    fontSize: "1.1rem",
                                  }}
                                >
                                  Gallery Images
                                </h5>
                                <span className="badge bg-kendo-primary rounded-pill">
                                  {EventDetail?.EventInnerimage?.length || 0}{" "}
                                  files
                                </span>
                              </div>

                              <div className="d-flex flex-wrap gap-3">
                                {EventDetail?.EventInnerimage?.map(
                                  (image: any) => (
                                    <div
                                      key={image.ID}
                                      className="position-relative"
                                      style={{
                                        width: "150px",
                                        transition: "all 0.3s ease",
                                      }}
                                    >
                                      <div className="card h-100 border-0 shadow-sm overflow-hidden">
                                        <div className="ratio ratio-1x1 bg-light overflow-hidden">
                                          <div
                                            style={{
                                              position: "absolute",
                                              width: "100%",
                                              height: "auto",
                                              display: "flex",
                                              justifyContent: "end",
                                            }}
                                          >
                                            <Button
                                              type="button"
                                              themeColor={"error"}
                                              fillMode={"solid"}
                                              style={{
                                                position: "relative",
                                                padding: "5px 10px",
                                                width: 30,
                                                height: 30,

                                                color: "#fff",
                                                zIndex: "1",
                                                borderRadius: "0 0 0 5px",
                                              }}
                                              onClick={() =>
                                                handleDeleteImage(image.ID)
                                              }
                                            >
                                              <IconComponent
                                                icon={MdDelete}
                                                className="absolute-position fs-5"
                                              />
                                            </Button>
                                          </div>
                                          <img
                                            className="img-fluid object-fit-cover"
                                            src={image?.ImageGallery}
                                            alt="Uploaded document"
                                            style={{
                                              cursor: "pointer",
                                              transition: "transform 0.3s",
                                            }}
                                            onMouseEnter={(e) =>
                                              (e.currentTarget.style.transform =
                                                "scale(1.05)")
                                            }
                                            onMouseLeave={(e) =>
                                              (e.currentTarget.style.transform =
                                                "scale(1)")
                                            }
                                            onClick={() =>
                                              window.open(
                                                `${image?.ImageGallery}`,
                                                "_blank",
                                              )
                                            }
                                          />
                                        </div>
                                      </div>
                                    </div>
                                  ),
                                )}
                              </div>
                            </div>
                          )}
                        </div>
                      </GridLayoutItem>
                    )}
                  <GridLayoutItem>
                    <Field
                      name={`IsActive`}
                      label="Status"
                      placeholder="i.e. Active"
                      component={FormSelectionField}
                      validator={requiredValidator}
                      astrike={true}
                      options={STATUSARRAY?.map((status: any) => {
                        return {
                          value: status?.value,
                          label: status?.label,
                        };
                      })}
                    />
                  </GridLayoutItem>
                  <GridLayoutItem
                    colSpan={2}
                    style={{
                      marginTop: 35,
                      textAlign: "end",
                    }}
                  >
                    <div>
                      <ButtonWithLoading
                        label={EventID ? "Update" : "Save"}
                        type="submit"
                        disabled={!formRenderProps.allowSubmit || loading}
                        loading={loading}
                      />
                      <Button
                        type="button"
                        fillMode={"outline"}
                        themeColor={"primary"}
                        style={{ marginLeft: 10 }}
                        onClick={() => navigate("/event")}
                      >
                        Cancel
                      </Button>
                    </div>
                  </GridLayoutItem>
                </GridLayout>
              </ShadowCard>
            </FormElement>
          )}
        />
      </div>
    </>
  );
};

const DeleteEventImageDialog: React.FC = () => {
  const dispatch = useAppDispatch();
  const dialogName = useAppSelector((state) => state.dialog.dialogName);
  const location = useLocation();
  const EventID = location.state?.EventID;
  const EventImageID = useAppSelector((state) => state.event.EventImageID);

  const handleDeleteAction = async (ID: number | null) => {
    if (ID) {
      const response = await dispatch(deleteEventsImage(ID));
      if (response.meta.requestStatus === "fulfilled") {
        if (EventID) {
          dispatch(getEventsByID(EventID));
        }
        dispatch(closeDialog());
        dispatch(clearEventImageID());
      } else {
        // if (EventID) {
        //   dispatch(getEventByID(EventID));
        // }
        dispatch(closeDialog());
        dispatch(clearEventImageID());
      }
    }
  };
  return (
    <>
      {dialogName === "deleteEventImage" && (
        <AppDialog>
          <>
            <Typography.h5>{"Delete Image?"}</Typography.h5>
            <GridLayout>
              <GridLayoutItem>
                <Typography.p>
                  Are you sure you want to delete this Image?
                </Typography.p>
              </GridLayoutItem>
              <GridLayoutItem
                style={{
                  display: "flex",
                  justifyContent: "end",
                }}
              >
                <DialogCloseButton themeColor="error" />
                <Button
                  fillMode={"solid"}
                  themeColor={"error"}
                  onClick={() => handleDeleteAction(EventImageID)}
                  type="button"
                >
                  Delete
                </Button>
              </GridLayoutItem>
            </GridLayout>
          </>
        </AppDialog>
      )}
    </>
  );
};

export default CreateEvent;
